import en from './transfers.i18n.json';

export const transfers = {
  en,
};
